import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const {  pathname } = location;
 
   return (
    <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
      <Link to="/" className="navbar-brand p-0">
        <h1 className="m-0">DGM</h1>
        {/* <img src="img/logo.png" alt="Logo"> */}
      </Link>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="fa fa-bars" />
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav mx-auto py-0">
          <Link to="/" className={pathname === '/' ? "nav-item nav-link active" : 'nav-item nav-link' }>
            Home
          </Link>
          <Link to="/about"  className={pathname === '/about' ? "nav-item nav-link active" : 'nav-item nav-link' }>
            About
          </Link>
          <Link to="/service" className={pathname === '/service' ? "nav-item nav-link active" : 'nav-item nav-link' }>
            Service
          </Link>
          <Link to="/project" className={pathname === '/project' ? "nav-item nav-link active" : 'nav-item nav-link' }>
            Project
          </Link>
  
          <Link to="/contact" className={pathname === '/contact' ? "nav-item nav-link active" : 'nav-item nav-link' }>
            Contact
          </Link>
        </div>
        {/* <div className="nav-item dropdown">
            <a
              href="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              Pages
            </a>
            <div className="dropdown-menu m-0">
              <Link to="/team" className="dropdown-item">
                Our Team
              </Link>
              <Link to="/testimonial" className="dropdown-item">
                Testimonial
              </Link>
              <Link to="/404" className="dropdown-item">
                404 Page
              </Link>
            </div>
          </div> */}
        <Link
          to="/contact"
          className="btn rounded-pill py-2 px-4 ms-3 d-none d-lg-block"
        >
          Get Started
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
